import { FC } from "react";
import classNames from "classnames";

import { AccordionItem } from "components/molecules/AccordionItem/AccordionItem";

import { AccordionItemRecord } from "@graphql/types/graphql";
import { StructuredText } from "components/sections/RichtextSection/StructuredText";
import { generateFaqMicroData } from "utils";

import s from "./Accordion.module.scss";

interface Props {
  items: AccordionItemRecord[];
  timeline?: boolean;
  activeItem?: string;
}

export const Accordion: FC<Props> = ({ items, timeline, activeItem }) => {
  if (timeline) {
    return (
      <ul className={s.List}>
        {items.map((item) => {
          const isOpen = Boolean(item.id && activeItem && item.id === activeItem);
          return (
            <li className={classNames(s.Item, s.ItemTimeline)} key={item.id}>
              <AccordionItem
                id={item.id}
                title={item.title}
                icon={item.icon}
                timeline={timeline}
                isOpen={isOpen}
              >
                <StructuredText structuredText={item.content as any} />
              </AccordionItem>
            </li>
          );
        })}
      </ul>
    );
  }

  const faqMicroData = generateFaqMicroData(items);

  return (
    <>
      {faqMicroData}
      <div>
        <ul className={s.List}>
          {items.map((item) => {
            const isOpen = Boolean(item.id && activeItem && item.id === activeItem);
            return (
              <li className={s.Item} key={item.id} itemScope itemType="https://schema.org/Question">
                <AccordionItem
                  id={item.id}
                  title={item.title}
                  icon={item.icon}
                  timeline={timeline}
                  isOpen={isOpen}
                >
                  <div
                    className="prose"
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <div itemProp="text">
                      <StructuredText structuredText={item.content as any} />
                    </div>
                  </div>
                </AccordionItem>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
